// getAllTags

import { computed, makeAutoObservable } from 'mobx';
import { apiCommon } from 'src/api/ApiCommon';
import { TagItemType } from 'src/api/config/tags/getAll';
import { Resource } from 'src_common/common/mobx-utils/Resource';

export class TagsState {
    private data: Resource<Map<string, TagItemType>>;

    constructor() {
        this.data = new Resource(async () => apiCommon.getAllTags.run({}));
        makeAutoObservable(this);
    }

    get allTags(): Map<string, TagItemType> | null {
        const data = this.data.get();

        if (data.type === 'ready') {
            return data.value;
        }

        return null;
    }

    @computed.struct get regions(): Array<{ id: string; name: string }> {
        const allTags = this.allTags?.get('region')?.values ?? [];

        const result = allTags
            .map((item) => ({
                id: item.id,
                name: item.label,
            }))
            .filter((item) => item.id !== '-');

        result.sort((a, b) => {
            if (a.name > b.name) {
                return 1;
            }
            if (a.name < b.name) {
                return -1;
            }

            return 0;
        });

        return [{ name: 'All', id: '' }, ...result];
    }
}
